import React from 'react';
import {
    Building2,
    Store,
    User,
    Package,
    ReceiptText,
    Tags,
    Calendar,
    Settings,
    ClipboardCheck,
    Megaphone,
    FileText,
    Tag,
    Bell,
    ListChecks,
    Trophy,
    ScanBarcode,
    ShieldCheck
} from 'lucide-react';
import { StatusTag } from '../../common';
import { t } from '../../../company/labels';

// Entity type → Lucide icon.
const ENTITY_ICONS = {
    CLIENT: Building2,
    STORE: Store,
    USER: User,
    PRODUCT: Package,
    PRICE: ReceiptText,
    STORETYPE: Tags,
    CALENDAR: Calendar,
    SYSTEM: Settings,
    STORE_CHECK: ClipboardCheck,
    CAMPAIGN: Megaphone,
    CONTRACT: FileText,
    TAG: Tag,
    NOTIFICATION: Bell,
    POLL: ListChecks,
    COMPETITION: Trophy,
    AUDIT: ScanBarcode,
    PERMISSION: ShieldCheck
};

// Short role labels used in the table and the detail view.
const USER_TYPE_LABELS = {
    admin: 'Admin',
    gerente: 'Gerente',
    asesor: 'Asesor',
    promotor: t('promotor'),
    auditor: 'Auditor',
    location: 'Ubicación',
    TradeMarketing: 'Trade Marketing',
    auditAnalyst: 'Análisis Auditor'
};

export function EntityIcon({ type }) {
    const Icon = ENTITY_ICONS[type] || FileText;
    return <Icon />;
}

/** Action pill. Activations/deactivations of an UPDATE get their own wording and color. */
export function ActionTag({ label, tone, isActivation, isDeactivation }) {
    if (isDeactivation) {
        return (
            <StatusTag tone="danger" dot>
                Desactivación
            </StatusTag>
        );
    }
    if (isActivation) {
        return (
            <StatusTag tone="success" dot>
                Activación
            </StatusTag>
        );
    }
    return (
        <StatusTag tone={tone} dot>
            {label}
        </StatusTag>
    );
}

export function UserTypeTag({ userType, tone }) {
    return <StatusTag tone={tone}>{USER_TYPE_LABELS[userType] || userType}</StatusTag>;
}
